import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';

const { ActionTypes } = Constants;

export const ErrorAction = {

    //write actions here
    log: function (error, logToConsole) {
        if (logToConsole) {
            console.log('error occurred: ', error);
        }
        dispatcher.dispatch({
            type: ActionTypes.ERROR_OCCURRED,
            error: error
        })
    },

    dumpErrors: function () {
        dispatcher.dispatch({
            type: ActionTypes.DUMP_ERRORS
        });
    },

    showModalError: function (message) {
        dispatcher.dispatch({
            type: ActionTypes.SHOW_MODAL_ERROR,
            message: message
        });
    },

    hideModalError: function () {
        dispatcher.dispatch({
            type: ActionTypes.HIDE_MODAL_ERROR
        });
    }

};
